<button mat-icon-button (click)="toggleTheme()" class="m-l-15 m-r-5">
  <mat-icon>{{ darkModeOn ? 'wb_sunny' : 'nights_stay' }}</mat-icon>
</button>
